/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ButtonOptionSystem from '../../../../components/NovoSistema/ButtonOptionSystem';
import LinkOptionSystem from '../../../../components/NovoSistema/LinkOptionSystem';
import { SelectSystemHeader } from '../../../../components/NovoSistema/SelectSystemHeader';
import OrcamCustos from './OrcamCustos';
import OrcamDeReceitas from './OrcamDeReceitas';
import OrcamDespAdm from './OrcamDespAdm';
import OrcamDespCom from './OrcamDespCom';
import OrcamRecDespFin from './OrcamRecDespFin';

export default function TemplateOrcamentoAnual() {
  const [systemOption, setSystemOption] = useState('');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Orçamento Anual" linkIcon="/images/icons/diamond.svg" />
        <SelectSystemHeader>
          <ButtonOptionSystem
            systemName="Orçam. de Receitas"
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. de Receitas' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Orçam. Custos"
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. Custos' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Orçam. Desp. Adm."
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. Desp. Adm.' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Orçam. Desp. Com."
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. Desp. Com.' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Orçam. Rec/Desp Fin."
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. Rec/Desp Fin.' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="Orçam. Investimento"
            color=""
            border="#70309F"
            active={systemOption === 'Orçam. Investimento' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <ButtonOptionSystem
            systemName="DRE Projetado"
            color=""
            border="#70309F"
            active={systemOption === 'DRE Projetado' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <LinkOptionSystem systemName="DFC Projetado" border="#70309F" width="130px" />
          <ButtonOptionSystem
            systemName="MDC e EBITDA"
            color=""
            border="#70309F"
            active={systemOption === 'MDC e EBITDA' ? true : false}
            setSystemOption={setSystemOption}
            width="130px"
          />
          <LinkOptionSystem systemName="Budget Empresa 1" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Budget Empresa 2" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="AGR Empresa 1" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="AGR Empresa 2" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Conc. Banc. Inter" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Conc. Banc. Itau" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Lista CDRs" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Racional Custos" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Racional Receitas" border="#70309F" width="130px" />
          <LinkOptionSystem systemName="Budget em EXCEL" border="#ffffff" bgColor="#1D6C41" width="130px" />
        </SelectSystemHeader>
        {systemOption === 'Orçam. de Receitas' && <OrcamDeReceitas />}
        {systemOption === 'Orçam. Custos' && <OrcamCustos />}
        {systemOption === 'Orçam. Desp. Adm.' && <OrcamDespAdm />}
        {systemOption === 'Orçam. Desp. Com.' && <OrcamDespCom />}
        {systemOption === 'Orçam. Rec/Desp Fin.' && <OrcamRecDespFin />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
